/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import * as tslib_1 from "tslib";
import { CrownTransform } from '../../CrownTransform';
import { CrownShape } from './CrownShape';
import { Shape } from './CrownShapeCap';
import { Solids } from '@sick-davinci/glow';
import { DoubleSide } from 'three';
let Shape3DEllipticCylinder = class Shape3DEllipticCylinder extends CrownShape {
    constructor(shape, decoration, material) {
        super(shape, decoration);
        CrownTransform.copyMatrix(shape.pose, this);
        const geometry = Solids.createCylinder(1, 1, shape.height);
        geometry.rotateX(Math.PI / 2);
        geometry.scale(shape.radiusX, shape.radiusY, 1);
        CrownTransform.copyMatrix(shape.pose, this);
        this.geometry = geometry;
        this.material = CrownShape.getFillMaterial(material, decoration, { side: DoubleSide });
        this.addOutline(geometry, decoration);
    }
    format() {
        const { source, t, r, s, Matrix } = this.transformPose();
        return {
            radiusX: s.x * source.radiusX,
            radiusY: s.y * source.radiusY,
            height: s.z * source.height,
            pose: {
                Type: r.length() > 0 ? 'RIGID' : t.length() > 0 ? 'TRANSLATION' : 'IDENTITY',
                Matrix,
            },
        };
    }
};
Shape3DEllipticCylinder = tslib_1.__decorate([
    Shape('Shape3D.EllipticCylinder'),
    tslib_1.__metadata("design:paramtypes", [Object, Object, Object])
], Shape3DEllipticCylinder);
export { Shape3DEllipticCylinder };
//# sourceMappingURL=Shape3DEllipticCylinder.js.map